import './styles.scss'

const Spinner = (): JSX.Element => (<div className="loader">Loading...</div>)

export default Spinner
